// AdvisorDetails.js
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "../../API";
import NavBar from "../Navbar";
import { Helmet } from "react-helmet-async";
import "./CategoryContent.css";

const SkeletonCard = () => (
    <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
        <div className="card shadow-sm h-100 placeholder-glow">
            <div className="placeholder w-100" style={{ height: "200px" }}></div>
            <div className="card-body">
                <div className="placeholder col-8 mb-2"></div>
                <div className="placeholder col-6"></div>
            </div>
        </div>
    </div>
);

const SocomAdvisorDetails = () => {
    const { advisor_Name } = useParams();
    const [advisor, setAdvisor] = useState({});
    const [channels, setChannels] = useState([]);
    const [allvedios, setallvedios] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const itemsPerPage = 12; // Set to 6 as per your requirement
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchAdvisor = async () => {
            try {
                setLoading(true);
                const { data } = await axios.get(
                    `${API}/api/advisor/by-name_slug/${advisor_Name}`
                );
                console.log("ddddddddddddddddddddd", data?.data?.MyActiveViseos)
                const advisorData = data?.data || {};
                const videoList = data?.data?.MyActiveViseos || [];

                setAdvisor(advisorData);
                setallvedios(videoList);
                setChannels(advisorData?.linkedNetworkChannels || []);

                // 🔥 FIX 1: Calculate total pages based on fetched video list
                setTotalPages(Math.ceil(videoList.length / itemsPerPage));
                setCurrentPage(1); // Reset to page 1 on new advisor fetch

                setLoading(false);
            } catch (err) {
                console.error("Advisor fetch failed:", err);
                setLoading(false);
            }
        };

        fetchAdvisor();
    }, [advisor_Name]);

    // 🔥 FIX 2: Ensure this returns the correct slice for the current page
    const getPaginatedData = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        return allvedios?.slice(startIndex, startIndex + itemsPerPage) || [];
    };

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setCurrentPage(newPage);
            window.scrollTo(0, 0); // Optional: Scroll to top on change
        }
    };

    const generateSlug = (name, id = "") => {
        if (!name) return "";
        const baseSlug = name.toLowerCase().trim().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "").replace(/-+/g, "-");
        return id ? `${baseSlug}-${id}` : baseSlug;
    };

    const generateChannellSlug = (name) => generateSlug(name);

    return (
        <>
            <Helmet>
                <title>{advisor?.name ? `${advisor.name} - SoCom Advisor` : "SoCom Advisor"}</title>
            </Helmet>

            <NavBar categoryLogo={advisor?.logo?.url} categoryId={`/apex_channel/${advisor_Name}`} />

            <div className="container py-4">
                {loading ? (
                    <div className="row">
                        {Array.from({ length: 8 }).map((_, i) => <SkeletonCard key={i} />)}
                    </div>
                ) : (
                    <>
                        {/* Banner */}
                        {advisor?.banner?.url && (
                            <div className="category-banner mb-4 shadow-lg overflow-hidden rounded">
                                <img
                                    src={advisor.banner.url}
                                    alt={advisor.name}
                                    className="img-fluid w-100"
                                    style={{
                                        aspectRatio: "21 / 9",
                                        objectFit: "cover", // Changed from 'fit' to 'cover' for better UI
                                        maxHeight: "550px",
                                        display: "block"
                                    }}
                                />
                            </div>
                        )}

                        {/* Channels */}
                        {channels?.length > 0 && (
                            <div className="mb-5">
                                <h4 className="mb-3">Explore Channels</h4>
                                <div className="row">
                                    {channels.map((channel) => (
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" key={channel._id}>
                                            <Link to={`/net_channel/${generateSlug(channel.name)}`} className="text-decoration-none">
                                                <div className="card shadow-sm h-100">
                                                    <img src={channel.thumbnail?.url} className="card-img-top" style={{ height: "180px", objectFit: "fill" }} alt={channel.name} />
                                                    <div className="card-body"><h5 className="card-title text-center text-dark">{channel.name}</h5></div>
                                                </div>
                                            </Link>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Videos */}
                        <div className="mb-5">
                            <h4 className="mb-3">View Videos</h4>
                            <div className="row">
                                {getPaginatedData().length > 0 ? (
                                    getPaginatedData().map((content) => (
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" key={content._id}>
                                            <Link to={
                                                // 🔥 FIX 3: Check channelType on the individual 'content' object
                                                content?.channelType === "Subchannels"
                                                    ? `/${generateChannellSlug(content?.channel?.parentChannel?.name)}/channel/${generateChannellSlug(content?.channel?.name)}/${generateSlug(content.title, content._id)}`
                                                    : content?.channelType === "SoComAdvisor"
                                                        ? `/${content.channel?.advisor_Name_Slug}/${generateSlug(content.title, content._id)}`
                                                        : `/${generateChannellSlug(content?.channel?.name)}/${generateSlug(content.title, content._id)}`
                                            } className="text-decoration-none">
                                                <div className="card shadow-sm h-100">
                                                    <img src={content.thumbnail} alt={content.title} className="card-img-top" style={{ height: '200px', objectFit: 'cover' }} />
                                                    <div className="card-body">
                                                        <h5 className="card-title text-center text-dark">{content.title}</h5>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-12 text-center text-muted py-5">
                                        <h5>No videos uploaded related to this.</h5>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Pagination UI */}
                        {allvedios?.length > itemsPerPage && (
                            <nav>
                                <ul className="pagination justify-content-center">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                                    </li>
                                    {Array.from({ length: totalPages }, (_, i) => (
                                        <li className={`page-item ${currentPage === i + 1 ? "active" : ""}`} key={i}>
                                            <button className="page-link" onClick={() => handlePageChange(i + 1)}>{i + 1}</button>
                                        </li>
                                    ))}
                                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                                    </li>
                                </ul>
                            </nav>
                        )}
                    </>
                )}
            </div>
        </>
    );
};

export default SocomAdvisorDetails;